import { useSearchParams } from "react-router-dom";
import EventOccasionService from "../../../services/EventOccasionService";
import { EventOccasion } from "../../../models";
import { useEffect, useState } from "react";
import { CreateEventOccasion } from "./ui/buttons";
import EventOccasionsTable from "./ui/event-occasions-table";
import EventOccasionsSkeleton from "./skeleton/event-occasions-skeleton";

export default function EventOccasionsPage() {
    const [searchParams] = useSearchParams();
       const api = new EventOccasionService();
       const [eventOccasions,setEventOccasions] = useState<EventOccasion[]>([]);
       const [loading, setLoading] = useState(true);

       useEffect(() => {     
         fetchEventOccasions();
       }, [searchParams.get("reload")]);
       
       const fetchEventOccasions = async () => {
         const data = await api.getEventOccasions();
         setEventOccasions(data);
         setLoading(false);     
       };
        
     return (
       <div className="w-full">
         <div className="flex w-full items-center justify-between">
           <h1 className={` text-2xl`}>Event Occasions</h1>
         </div>
         <CreateEventOccasion />
         {loading ? <EventOccasionsSkeleton /> : <EventOccasionsTable eventOccasions={eventOccasions} />}
       </div>
     );
   
}



